import { CareerId } from '@common/const/catalog/career';
import { ROUTES_DEFAULT_CITY_ID } from '@common/const/routes/defaultCity';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CatalogFeedbacksProps } from 'src/widgets/catalog/feedback/list/types';

export const HOME_CAREER_LIST_MAX_WIDTH = 1396;

export const HOME_FEEDBACKS_LIST_PARAMETERS: CatalogFeedbacksProps = {
  careerId: CareerId.Nanny,
  catalogType: CatalogItemType.Resume,
  cityId: ROUTES_DEFAULT_CITY_ID,
  productName: 'Домашний персонал',
};
